import * as API from '../api'
export const FETCH_CID = 'FETCH_CID'
export const FETCHING_CID = 'FETCHING_CID'
export const FETCH_CID_ERROR = 'FETCH_CID_ERROR'
export const FETCH_CIDS = 'FETCH_CIDS'
export const FETCHING_CIDS = 'FETCHING_CIDS'
export const FETCH_CIDS_ERROR = 'FETCH_CIDS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_CID = 'CHANGE_CID'
export const DELETE_CID = 'DELETE_CID'
export const ADD_CID = 'ADD_CID'
export const EDIT_CID = 'EDIT_CID'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_CID = 'NEW_FORM_CID'
export const CID_FORM_ERROR = 'CID_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeCid = cid => {
  return dispatch => {
    dispatch({ type: CHANGE_CID, cid })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleCidError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: CID_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormCid = cid => {
  return dispatch => {
    dispatch({ type: NEW_FORM_CID })
  }
}

export const setCidFormTouched = cid => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreCid = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CIDS })
    return API.cids
      .restoreCid(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_CID, cid: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CIDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleCidError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchCids = options => {
  return dispatch => {
    dispatch({ type: FETCHING_CIDS })
    return API.cids
      .getCids(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_CIDS,
          cids: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CIDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteCid = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CIDS })
    return API.cids
      .deleteCid(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_CID, cid: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CIDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addCid = cid => {
  return dispatch => {
    dispatch({ type: FETCHING_CIDS })
    dispatch({ type: FETCHING_CID })
    return API.cids
      .addCid({ cid: cid })
      .then(({ data }) => {
        dispatch({ type: ADD_CID, cid: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleCidError(response, dispatch)
        dispatch({
          type: FETCH_CIDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editCid = cid => {
  return dispatch => {
    dispatch({ type: FETCHING_CIDS })
    dispatch({ type: FETCHING_CID })
    return API.cids
      .editCid({ cid: cid })
      .then(({ data }) => {
        dispatch({ type: EDIT_CID, cid: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CIDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleCidError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchCid = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CID, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.cids
      .getCid(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_CID, cid: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CID_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/cids.js